export default __webpack_public_path__ + "static/media/chat-icon.ff7f5318.svg";